import { createGlobalState } from "react-hooks-global-state";

const { useGlobalState } = createGlobalState({ zap: null });

export const GlobalState = useGlobalState;
